import $ from 'jquery';
import Config from './config';

import Common from './module/common';


import CapabilitiesModule from './module/capabilities';
import ConfigurationModule from './module/configuration';
import Contract from './model/contract';
import ContractsFormModule from './module/tasks/contracts.form';
import ContractsListModule from './module/tasks/contracts.list';
import FieldsListModule from './module/refbooks/fields.list';
import Field from './model/refbooks/field';
import FieldsFormBoundTypesModule from './module/refbooks/fields.form.types';
import FieldsFormNestedFieldsModule from './module/refbooks/fields.form.nested-fields';
import FieldsFormBoundStickersModule from './module/refbooks/fields.form.bound-stickers';
import FieldsFormTemplateModule from './module/refbooks/fields.form.template';
import Module from './core/module';
import ScriptsFormModule from './module/refbooks/scripts.form';
import ScriptsListModule from './module/refbooks/scripts.list';
import ServersListModule from './module/refbooks/servers.list';
import PrioritiesListModule from './module/refbooks/priorities.list';
import RefbooksModule from './module/refbooks/refbooks.module';
import Script from './model/refbooks/script';
import Schedule from './model/schedule';
import ScheduleCalendarModule from './module/schedule/calendar';
import ScheduleTasksModule from './module/schedule/tasks';
import ScheduleTemplatesModule from './module/schedule/templates.list';
import ScheduleFormModule from './module/schedule/form';
import ScheduleListModule from './module/schedule/list';
import ScheduleFilters from './view/module/schedule/launch.filters';
import ScheduleRunsModule from './module/schedule/runs';
import ScheduleTemplateModule from './module/schedule/templates.form';
import StatusesListModule from './module/refbooks/statuses.list';
import Sticker from './model/sticker';
import StickersListModule from './module/refbooks/stickers.list';
import StickersFormModule from './module/refbooks/stickers.form';
import Task from './model/task';
import TaskModule from './module/tasks/form';
import TasksModule from './module/tasks/list';
import MapModule from './module/tasks/map';
import Type from './model/newstype';
import TypesListModule from './module/refbooks/types.list';
import TypesFormModule from './module/refbooks/types.form';
import TypeGroupsListModule from './module/refbooks/type.groups.list';

import { today, unixts, datify, parseYYYYMMDD } from './utils/date';
import { route, event, } from './core/router';
import { restore, replace, popup, closePopup, rejectPopup, handle, } from './core/routing';





const commonModule = new Common( {} );
const schedulesModule = commonModule;





export default {

    [route( '' )]:
        handle( restore, commonModule, TasksModule ),

    [route( 'tasks' )]: 
        handle( restore, commonModule, TasksModule ),

    [route( 'map' )]: 
        handle( restore, commonModule, MapModule ),

    [route( 'task/:id' )]: 
        handle( restore, commonModule, TaskModule, 
            (moduleState, id) => Task.byId( id ) ),

    [event( TasksModule.OPEN_LIST )]:
        handle( replace, commonModule, TasksModule,
            filtersState => ({
                moduleState: { ...filtersState, },
            }) ),
    
    [event( TasksModule.OPEN_MAP )]:
        handle( replace, commonModule, MapModule,
            filtersState => ({
                moduleState: { ...filtersState, },
            }) ),
    
    [event( TasksModule.OPEN_TASK )]:
        handle( popup, commonModule, TaskModule ),

    [event( TaskModule.BACK )]:
        handle( closePopup ),

    [event( TasksModule.OPEN_CONTRACTS )]:
        handle( replace, commonModule, ContractsListModule,
            tasksFiltersState => ({
                moduleState: { tasksFiltersState, },
            }) ),
        
    [event( ContractsFormModule.OPEN )]:
        handle( popup, commonModule, ContractsFormModule,
            contract => contract || new Contract() ),

    [route( 'contracts/list' )]: 
        handle( restore, commonModule, ContractsListModule ),

    [route( 'contracts/new' )]: 
        handle( restore, commonModule, ContractsFormModule,
            () => new Contract() ),
        
    [route( 'contracts/:id' )]: 
        handle( restore, commonModule, ContractsFormModule, 
            (moduleState, id) => Contract.byId( +id ) ),
    
    



    [route( 'schedule/stats/:yyyymm' )]:
        handle( restore, schedulesModule, ScheduleCalendarModule,
            ({ date, ...moduleState }, yyyymm) => ({
                moduleState,
                moduleArgs: [{
                    month: parseYYYYMMDD( `${yyyymm}-01` ), 
                    date
                }],
            }) ),

    [event( ScheduleCalendarModule.TOGGLE_LIST_VIEW)]:
        handle( replace, schedulesModule, ScheduleListModule,
            (month, date, filters, scheduleId, time) => ({
                moduleState: { 
                    month: unixts( datify( month ) ),
                    date: unixts( datify( date ) ),
                    filters, 
                    scheduleId,
                    time,
                    page: 1
                },
            }) ),

    [route( 'schedule/runs/:yyyymmdd' )]:
        handle( restore, schedulesModule, ScheduleRunsModule,
            ({ month, ...moduleState }, yyyymmdd) => ({
                moduleState,
                moduleArgs: [month, parseYYYYMMDD( yyyymmdd )],
            }) ),

    [route( 'schedule/list' )]:
        handle( restore, schedulesModule, ScheduleListModule ),

    [event( ScheduleFormModule.POPUP_NEW )]:
        handle( popup, schedulesModule, ScheduleFormModule,
            () => [{ schedule: new Schedule() }] ),
        
    [event( ScheduleFormModule.POPUP_EDIT )]:
        handle( popup, schedulesModule, ScheduleFormModule,
            // may be passed 99, '99', { scheduleAttrs }
            arg => [isNaN( +arg )
                ? { schedule: arg }
                : { id: arg }] ),
    
    [route( 'schedule/new/:groupType/random/:yyyy' )]:
        handle( restore, schedulesModule, ScheduleFormModule,
            (moduleState, groupType, yyyy) =>  
                [{ schedule: new Schedule(), groupType, openedTab: 'random', yyyy }] ),
                                
    [route( 'schedule/new/:groupType/:openedTab' )]:
        handle( restore, schedulesModule, ScheduleFormModule,
            (moduleState, groupType, openedTab) => 
                [{ schedule: new Schedule(), groupType, openedTab }] ),

    [route( 'schedule/:id/edit/:groupType/random/:yyyy' )]:
        handle( restore, schedulesModule, ScheduleFormModule,
            (moduleState, id, groupType, yyyy) => 
                [{ id, groupType, openedTab: 'random', yyyy }] ),
        
    [route( 'schedule/:id/edit/:groupType/:openedTab' )]:
        handle( restore, schedulesModule, ScheduleFormModule,
            (moduleState, id, groupType, openedTab) =>
                [{ id, groupType, openedTab }] ),
    
    [route( 'schedule/:id/template/:templateTaskId' )]:
        handle( restore, schedulesModule, ScheduleTemplateModule,
            (moduleState, scheduleId, templateTaskId) => 
                [{ scheduleId, templateTaskId }] ),
    
    [route( 'schedule/:id/new-template' )]:
        handle( restore, schedulesModule, ScheduleTemplateModule,
            (moduleState, scheduleId) => 
                [{ scheduleId, templateTask: new Task( { is_template: true } ) }] ),

    [route( 'schedule/:id/tasks/:yyyymmdd/@/:hhmm' )]:
        handle( restore, schedulesModule, ScheduleTasksModule,
            ({ month, ...moduleState }, scheduleId, yyyymmdd, hhmm) => ({
                moduleState,
                moduleArgs: [{
                    scheduleId, 
                    time: hhmm.replace( '-', ':' ), 
                    month, 
                    date: parseYYYYMMDD( yyyymmdd )
                }],
            } ) ),

    [route( 'schedule/:id/tasks/:yyyymmdd' )]:
        handle( restore, schedulesModule, ScheduleTasksModule,
            ({ month, ...moduleState }, scheduleId, yyyymmdd) => ({
                moduleState,
                moduleArgs: [{
                    scheduleId, 
                    month, 
                    date: parseYYYYMMDD( yyyymmdd )
                }],
            } ) ),
    
    [route( 'schedule/:id/stats/:yyyymm/@/:hhmm' )]:
        handle( restore, schedulesModule, ScheduleCalendarModule,
            ({ date, ...moduleState }, scheduleId, yyyymm, hhmm) => ({
                        moduleState,
                        moduleArgs: [{
                            scheduleId, 
                            time: hhmm.replace( '-', ':' ), 
                            date,
                            month: parseYYYYMMDD( `${yyyymm}-01` )
                        }],
                    } ) ),

    [route( 'schedule/:id/stats/:yyyymm' )]:
        handle( restore, schedulesModule, ScheduleCalendarModule,
            ({ date, time, ...moduleState }, scheduleId, yyyymm) => ({
                        moduleState,
                        moduleArgs: [{
                            scheduleId, time, date,
                            month: parseYYYYMMDD( `${yyyymm}-01` )
                        }],
                    } ) ),
        
    [route( 'schedule/:id/templates' )]:
        handle( restore, schedulesModule, ScheduleTemplatesModule,
            (moduleState, id) => [{ id }] ),
                                        
    [route( 'schedule' )]:
        handle( restore, schedulesModule, ScheduleCalendarModule,
            (moduleState = {}) => {
                if (!moduleState.filters)
                    moduleState.filters = ScheduleFilters.defaultFilterValues();

                return {
                    moduleState,
                    moduleArgs: [{
                        month: today(), 
                        date: today()
                    }],
                };
            } ),
    
    [event( ScheduleCalendarModule.OPEN_LAUNCHES_DAILY )]:
        handle( replace, schedulesModule, ScheduleRunsModule,
            (month, date, filters) => ({
                moduleState: { filters, page: 1, },
                moduleArgs: [month, date],
            }) ),

    [event( ScheduleTemplateModule.POPUP_NEW )]:
        handle( popup, schedulesModule, ScheduleTemplateModule,
            // may be passed 99, '99', { scheduleAttrs }
            arg => [isNaN( +arg )
                ? { schedule: arg, templateTask: new Task( { is_template: true } ) }
                : { scheduleId: arg, templateTask: new Task( { is_template: true } ) }] ),

    [event( ScheduleTemplateModule.POPUP_EDIT )]:
        handle( popup, schedulesModule, ScheduleTemplateModule,
            // may be passed 99, '99', { scheduleAttrs }
            (arg, templateTaskId) => [isNaN( +arg )
                ? { schedule: arg, templateTaskId }
                : { scheduleId: arg, templateTaskId }] ),

    [event( ScheduleTasksModule.REPLACE )]:
        handle( replace, schedulesModule, ScheduleTasksModule,
            (scheduleId, time, month, date, filters) => ({
                moduleState: { filters, },
                moduleArgs: [{ scheduleId, time, month, date }],
            }) ),
        
    [event( ScheduleTemplatesModule.POPUP )]:
        handle( popup, schedulesModule, ScheduleTemplatesModule,
            // may be passed 99, '99', { scheduleAttrs }
            arg => ({
                moduleState: { 
                    filters: ScheduleFilters.defaultFilterValues(), 
                    page: 1, 
                },
                moduleArgs: isNaN( +arg )
                    ? [{ schedule: arg }]
                    : [{ id: arg }],
            }) ),

    [event( ScheduleTemplatesModule.REPLACE )]:
        handle( replace, schedulesModule, ScheduleTemplatesModule,
            // may be passed 99, '99', { scheduleAttrs }
            arg => ({
                moduleState: { 
                    filters: ScheduleFilters.defaultFilterValues(), 
                    page: 1, 
                },
                moduleArgs: isNaN( +arg )
                    ? [{ schedule: arg }]
                    : [{ id: arg }],
            }) ),

    [event( ScheduleCalendarModule.TOGGLE_CALENDAR )]:
        handle( replace, schedulesModule, ScheduleCalendarModule,
            (scheduleId, time, month, date, filters) => ({
                moduleState: { filters },
                moduleArgs: [{ scheduleId, time, month, date }],
            }) ),

    [event( Module.BACK )]:
        handle( closePopup ),
    




    [event( RefbooksModule.CAPABILITIES )]:
        handle( replace, commonModule, CapabilitiesModule,
            ({ cluster, }) => ({
                moduleState: {
                    cluster,
                    filters: {},
                    sort: 'role',
                    direction: 'asc',
                    page: 1,
                    limit: 10,
                }
            }) ),

    [route( 'capabilities' )]: 
        handle( restore, commonModule, CapabilitiesModule,
            (moduleState = {}) => {
                if (!moduleState.filters)
                    moduleState.filters = {};
                if (!moduleState.sort)
                    moduleState.sort = 'role',
                    moduleState.direction = 'asc';
                if (!moduleState.page)
                    moduleState.page = 1;
                if (!moduleState.limit)
                    moduleState.limit = 10;

                return {
                    moduleState,
                    moduleArgs: [],
                };
            } ),

    [event( RefbooksModule.PRIORITIES )]:
        handle( replace, commonModule, PrioritiesListModule,
            ({ cluster, }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'priorities' )]: 
        handle( restore, commonModule, PrioritiesListModule,
            ({ page = 1, limit = 10, sort = 'order', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster,
                }
            }) ),
        
    [event( RefbooksModule.STATUSES )]:
        handle( replace, commonModule, StatusesListModule,
            ({ cluster, }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'order', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'statuses' )]: 
        handle( restore, commonModule, StatusesListModule, 
            ({ page = 1, limit = 10, sort = 'order', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster,
                }
            }) ),





    [route( 'stickers/new' )]: 
        handle( restore, commonModule, StickersFormModule, 
            () => new Sticker() ),

    [route( 'stickers/:id/edit' )]: 
        handle( restore, commonModule, StickersFormModule, 
            ({ sort, direction, page, limit, search, activeId, }, id) => Sticker.byId( +id )
                .then( stickerFetched => ({
                    moduleState: { sort, direction, page, limit, search, activeId, },
                    moduleArgs: [stickerFetched],
                }) ) ),

    [event( StickersFormModule.OPEN_STICKER )]:
        handle( popup, commonModule, StickersFormModule,
            (stickerModel, cluster) => {
                let promise;
                if (stickerModel instanceof Sticker)
                    promise = stickerModel.id
                        ? Sticker.byId( +stickerModel.id )
                        : Promise.resolve( stickerModel );
                else
                    promise = Sticker.byId( +stickerModel );

                return promise.then( stickerFetched => ({
                    moduleState: { cluster, sort: 'name', direction: 'asc', page: 1, limit: 10, search: '', },
                    moduleArgs: [stickerFetched],
                }) );
            } ),

    [event( RefbooksModule.STICKERS )]:
        handle( replace, commonModule, StickersListModule,
            ({ cluster }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'stickers' )]: 
        handle( restore, commonModule, StickersListModule,
            ({ page = 1, limit = 10, sort = 'title', direction = 'asc', search = '', activeId, cluster }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster
                }
            }) ),





    [route( 'fields/new/bound-types' )]: 
        handle( restore, commonModule, FieldsFormBoundTypesModule, 
            () => ({
                field: new Field()
            }) ),

    [route( 'fields/new/nested-fields' )]: 
        handle( restore, commonModule, FieldsFormNestedFieldsModule, 
            () => ({
                field: new Field( { format: 'composite' } )
            }) ),
    
    [route( 'fields/new/bound-stickers' )]: 
        handle( restore, commonModule, FieldsFormBoundStickersModule, 
            () => ({
                field: new Field( { format: 'file' } )
            }) ),
    
    [route( 'fields/:id/edit/bound-types' )]: 
        handle( restore, commonModule, FieldsFormBoundTypesModule, 
            (moduleState, id) => Field.byId( +id )
                .then( field => ({
                    moduleState,
                    moduleArgs: [{ field }],
                }) ) ),

    [route( 'fields/:id/edit/nested-fields' )]: 
        handle( restore, commonModule, FieldsFormNestedFieldsModule, 
            (moduleState, id) => Field.byId( +id )
                .then( field => ({
                    moduleState,
                    moduleArgs: [{ field }],
                }) ) ),

    [route( 'fields/:id/edit/bound-stickers' )]: 
        handle( restore, commonModule, FieldsFormBoundStickersModule,
            (moduleState, id) => Field.byId( +id )
                .then( field => ({
                    moduleState,
                    moduleArgs: [{ field }],
                }) ) ),

    [event( FieldsFormTemplateModule.OPEN_FIELD )]:
        handle( popup, commonModule, FieldsFormBoundTypesModule,
            (field, cluster) => {
                const promise = field instanceof Field
                    ? Promise.resolve( field )
                    : Field.byId( +field );

                return promise.then( field => ({
                    moduleState: { cluster, sort: 'name', direction: 'asc', page: 1, limit: 10, search: '', },
                    moduleArgs: [{ field }],
                }) );
            } ),

    [event( FieldsFormTemplateModule.TOGGLE_BOUND_TYPES )]:
        handle( replace, commonModule, FieldsFormBoundTypesModule,
            // field is always Model, not id
            (field, original, moduleState) => ({
                moduleState,
                moduleArgs: [{ field, original }]
            }) ),
    
    [event( FieldsFormTemplateModule.TOGGLE_NESTED_FIELDS )]:
        handle( replace, commonModule, FieldsFormNestedFieldsModule,
            // field is always Model, not id
            (field, original, moduleState) => ({
                moduleState,
                moduleArgs: [{ field, original }]
            }) ),
    
    [event( FieldsFormTemplateModule.TOGGLE_BOUND_STICKERS )]:
        handle( replace, commonModule, FieldsFormBoundStickersModule,
            // field is always Model, not id
            (field, original, moduleState) => ({
                moduleState,
                moduleArgs: [{ field, original }]
            }) ),
    
    [event( RefbooksModule.FIELDS )]:
        handle( replace, commonModule, FieldsListModule,
            ({ cluster, }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'custom-fields' )]: 
        handle( restore, commonModule, FieldsListModule,
            ({ page = 1, limit = 10, sort = 'name', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster
                }
            }) ),





    [event( RefbooksModule.TYPEGROUPS )]:
        handle( replace, commonModule, TypeGroupsListModule,
            ({ cluster, }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'types/groups' )]: 
        handle( restore, commonModule, TypeGroupsListModule,
            ({ page = 1, limit = 10, sort = 'name', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster,
                }
            }) ),
            
            
    

    
    [route( 'types/new' )]: 
        handle( restore, commonModule, TypesFormModule, 
            () => new Type() ),

    [route( 'types/:id/edit' )]: 
        handle( restore, commonModule, TypesFormModule, 
            ({ sort, direction, page, limit, search, activeId, }, id) => Type.byId( +id )
                .then( typeFetched => ({
                    moduleState: { sort, direction, page, limit, search, activeId, },
                    moduleArgs: [typeFetched],
                }) ) ),

    [event( TypesFormModule.OPEN_TYPE )]:
        handle( popup, commonModule, TypesFormModule,
            (typeModel, cluster) => {
                const promise = typeModel instanceof Type
                    ? Promise.resolve( typeModel )
                    : Type.byId( +typeModel );

                return promise.then( typeFetched => ({
                    moduleState: { cluster, sort: 'name', direction: 'asc', page: 1, limit: 10, search: '', },
                    moduleArgs: [typeFetched],
                }) );
            } ),

    [route( 'types' )]: 
        handle( restore, commonModule, TypesListModule,
            ({ page = 1, limit = 10, sort = 'name', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster,
                }
            }) ),

    [event( RefbooksModule.TYPES )]:
        handle( replace, commonModule, TypesListModule,
            ({ cluster }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),
    
            
        


    [event( RefbooksModule.SERVERS )]:
        handle( replace, commonModule, ServersListModule,
            ({ cluster }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                }
            }) ),

    [route( 'scripts/servers/list' )]: 
        handle( restore, commonModule, ServersListModule,
            ({ page = 1, limit = 10, sort = 'name', direction = 'asc', search = '', activeId, cluster, }) => ({
                moduleState: {
                    page, limit, sort, direction, search, activeId, cluster,
                }
            }) ),

    // all filter parameters have values; don't use defaults here
    [route( 'scripts/list/:type/:op' )]: 
        handle( restore, commonModule, ScriptsListModule,
            (moduleState, type, operation) => ({
                moduleState: {
                    ...moduleState,
                    operation: operation.toUpperCase(),
                    type: type.toUpperCase(),
                }
            }) ),
    
    [event( RefbooksModule.SCRIPTS )]:
        handle( replace, commonModule, ScriptsListModule,
            ({ cluster }) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster,
                    operation: 'ALL-OPS',
                    type: 'ALL-TYPES',
                }
            }) ),

    [route( 'scripts/list' )]: 
        // default route; set filter parameters
        handle( restore, commonModule, ScriptsListModule,
            (/*moduleState*/) => ({
                moduleState: {
                    page: 1, limit: 10, sort: 'title', direction: 'asc', search: '',
                    operation: 'ALL-OPS',
                    type: 'ALL-TYPES',
                }
            }) ),

    [route( 'scripts/new/validation/insert' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'INSERT', type: 'VALIDATION', } )] ),

    [route( 'scripts/new/validation/update' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'UPDATE', type: 'VALIDATION', } )] ),
    
    [route( 'scripts/new/validation/delete' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'DELETE', type: 'VALIDATION', } )] ),
        
    [route( 'scripts/new/reaction/insert' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'INSERT', type: 'REACTION', } )] ),

    [route( 'scripts/new/reaction/update' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'UPDATE', type: 'REACTION', } )] ),
        
    [route( 'scripts/new/reaction/delete' )]: 
        handle( restore, commonModule, ScriptsFormModule,
            () => [new Script( { operation: 'DELETE', type: 'REACTION', } )] ),
        
    [route( 'scripts/:id' )]: 
        handle( restore, commonModule, ScriptsFormModule, 
            (moduleState, id) => Script.byId( +id )
                .then( script => [script] ) ),

    [event( ScriptsFormModule.NEW )]:
        handle( popup, commonModule, ScriptsFormModule,
            (script, cluster) => ({
                moduleState: { cluster },
                moduleArgs: [script],
            }) ),
    
    [event( ScriptsFormModule.EDIT )]:
        handle( popup, commonModule, ScriptsFormModule ),

                



    [route( 'configuration' )]: 
        handle( restore, commonModule, ConfigurationModule ),






}



// WEBPACK FOOTER //
// ./src/js/routes.js